// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* frontend/src/styles/Production.css - UPDATED WITH LIGHT THEME */

/* Error Boundary Styles */
.error-boundary {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--bg-secondary); /* Light gray background */
  text-align: center;
  padding: 2rem;
}

.error-boundary h1 {
  color: var(--error-color); /* Red error text */
  margin-bottom: 1rem;
}

.error-boundary p {
  color: var(--text-secondary); /* Medium gray text */
  margin-bottom: 1.5rem;
}

/* Use primary button style for refresh */
.error-boundary .submit-button {
  /* Inherit styles from ResumeEnhancement.css or define here */
  background-image: var(--gradient-button);
  background-color: var(--primary-red-medium);
  color: var(--text-on-gradient);
  padding: 0.75rem 1.5rem;
  font-size: 1rem;
  font-weight: 600;
  border: none;
  border-radius: var(--border-radius-full);
  cursor: pointer;
  transition: all 0.3s ease;
  min-width: 150px;
}
.error-boundary .submit-button:hover:not(:disabled) {
  box-shadow: var(--shadow-button-hover);
  transform: scale(1.03);
}

/* Loading Spinner Container */
.loading-spinner-container {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(255, 255, 255, 0.9); /* White overlay */
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

.loading-spinner {
    text-align: center;
}

.loading-spinner .spinner {
  width: 60px;
  height: 60px;
  border: 4px solid rgba(0, 0, 0, 0.1); /* Light gray spinner track */
  border-top-color: var(--text-accent); /* Red spinner color */
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin: 0 auto 1rem; /* Added margin */
}

.loading-spinner p {
  color: var(--text-primary); /* Dark text */
  font-size: 1.2rem;
}

@keyframes spin {
  to { transform: rotate(360deg); }
}

/* Toast Notifications */
.toast-container {
  position: fixed;
  top: calc(var(--navbar-height) + 1rem); /* Position below navbar */
  right: 20px;
  z-index: 9999;
  max-width: 400px; /* Limit width */
}

.toast {
  background: var(--bg-primary); /* White background */
  color: var(--text-primary); /* Dark text */
  border-radius: var(--border-radius-lg); /* Consistent rounding */
  padding: 1rem 1.5rem;
  margin-bottom: 1rem;
  box-shadow: var(--shadow-xl); /* Use defined shadow */
  animation: slideIn 0.3s ease;
  display: flex;
  align-items: center;
  gap: 1rem;
}

.toast.success { border-left: 4px solid var(--success-color); } /* Green */
.toast.error { border-left: 4px solid var(--error-color); } /* Red */
.toast.warning { border-left: 4px solid var(--warning-color); } /* Amber */

.toast-message {
  flex: 1 1;
  color: var(--text-primary); /* Dark text */
}

.toast-close {
  background: none;
  border: none;
  color: var(--text-secondary); /* Medium gray */
  font-size: 1.5rem;
  cursor: pointer;
  padding: 0;
  line-height: 1;
}

.toast-close:hover {
  color: var(--text-primary); /* Dark gray on hover */
}

@keyframes slideIn {
  from { transform: translateX(100%); opacity: 0; }
  to { transform: translateX(0); opacity: 1; }
}

/* Secure Form Indicators */
.secure-indicator {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  color: var(--text-secondary); /* Medium gray */
  font-size: 0.9rem;
  margin-top: 0.5rem;
}

.secure-indicator svg {
  width: 16px;
  height: 16px;
  color: var(--success-color); /* Green icon */
}

/* File Upload Security */
.file-security-notice {
  background: var(--bg-secondary); /* Light gray background */
  border: 1px solid var(--border-primary); /* Light border */
  border-radius: var(--border-radius-lg); /* Consistent rounding */
  padding: 0.8rem 1rem;
  margin-top: 1rem;
  font-size: 0.9rem;
  color: var(--text-secondary); /* Medium gray text */
}

.file-security-notice ul {
  margin: 0.5rem 0 0 1.5rem;
  padding: 0;
}

/* Session Warning */
.session-warning {
  position: fixed;
  top: calc(var(--navbar-height) + 1rem); /* Below navbar */
  left: 50%;
  transform: translateX(-50%);
  background: var(--warning-bg-light); /* Light amber background */
  color: var(--warning-color); /* Amber text */
  padding: 1rem 2rem;
  border-radius: var(--border-radius-lg);
  box-shadow: var(--shadow-lg);
  border: 1px solid var(--warning-color); /* Amber border */
  z-index: 9998;
  animation: pulseWarning 2s ease infinite;
}

@keyframes pulseWarning {
  0%, 100% { transform: translateX(-50%) scale(1); opacity: 1; }
  50% { transform: translateX(-50%) scale(1.02); opacity: 0.9; }
}

/* Network Status Indicator */
.network-status {
  position: fixed;
  bottom: 20px;
  left: 20px;
  background: var(--bg-primary); /* White background */
  padding: 0.8rem 1.5rem;
  border-radius: var(--border-radius-full); /* Pill shape */
  display: flex;
  align-items: center;
  gap: 0.5rem;
  z-index: 1000;
  box-shadow: var(--shadow-lg);
  font-size: 0.9rem;
}

.network-status.online {
  border: 1px solid var(--success-color); /* Green border */
  color: var(--success-color); /* Green text */
}

.network-status.offline {
  border: 1px solid var(--error-color); /* Red border */
  color: var(--error-color); /* Red text */
}

.network-indicator {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  animation: pulse 2s infinite;
}

.network-status.online .network-indicator { background: var(--success-color); }
.network-status.offline .network-indicator { background: var(--error-color); }

/* Accessibility Improvements */
.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}

/* Focus Visible Styles */
*:focus-visible {
  outline: 2px solid var(--text-accent); /* Red outline */
  outline-offset: 2px;
}

/* Skip to Content Link */
.skip-to-content {
  position: absolute;
  top: -40px;
  left: 0;
  background: var(--gradient-button); /* Red gradient */
  color: white;
  padding: 0.5rem 1rem;
  text-decoration: none;
  border-radius: 0 0 var(--border-radius-lg) 0; /* Rounded bottom right */
  z-index: 10000;
  transition: top 0.3s ease; /* Add transition */
}

.skip-to-content:focus {
  top: 0;
}

/* Responsive improvements */
@media (max-width: 768px) {
  .toast-container {
    left: 20px;
    right: 20px;
    max-width: none;
  }

  .session-warning {
    left: 20px;
    right: 20px;
    transform: none;
    text-align: center;
  }
}

@media (prefers-reduced-motion: reduce) {
  * {
    animation-duration: 0.01ms !important;
    animation-iteration-count: 1 !important;
    transition-duration: 0.01ms !important;
    scroll-behavior: auto !important; /* Disable smooth scroll */
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/Production.css"],"names":[],"mappings":"AAAA,kEAAkE;;AAElE,0BAA0B;AAC1B;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,+BAA+B,EAAE,0BAA0B;EAC3D,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,yBAAyB,EAAE,mBAAmB;EAC9C,mBAAmB;AACrB;;AAEA;EACE,4BAA4B,EAAE,qBAAqB;EACnD,qBAAqB;AACvB;;AAEA,yCAAyC;AACzC;EACE,6DAA6D;EAC7D,wCAAwC;EACxC,2CAA2C;EAC3C,8BAA8B;EAC9B,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,wCAAwC;EACxC,eAAe;EACf,yBAAyB;EACzB,gBAAgB;AAClB;AACA;EACE,sCAAsC;EACtC,sBAAsB;AACxB;;AAEA,8BAA8B;AAC9B;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oCAAoC,EAAE,kBAAkB;EACxD,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;IACI,kBAAkB;AACtB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oCAAoC,EAAE,6BAA6B;EACnE,oCAAoC,EAAE,sBAAsB;EAC5D,kBAAkB;EAClB,kCAAkC;EAClC,mBAAmB,EAAE,iBAAiB;AACxC;;AAEA;EACE,0BAA0B,EAAE,cAAc;EAC1C,iBAAiB;AACnB;;AAEA;EACE,KAAK,yBAAyB,EAAE;AAClC;;AAEA,wBAAwB;AACxB;EACE,eAAe;EACf,sCAAsC,EAAE,0BAA0B;EAClE,WAAW;EACX,aAAa;EACb,gBAAgB,EAAE,gBAAgB;AACpC;;AAEA;EACE,6BAA6B,EAAE,qBAAqB;EACpD,0BAA0B,EAAE,cAAc;EAC1C,sCAAsC,EAAE,wBAAwB;EAChE,oBAAoB;EACpB,mBAAmB;EACnB,4BAA4B,EAAE,uBAAuB;EACrD,4BAA4B;EAC5B,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA,iBAAiB,2CAA2C,EAAE,EAAE,UAAU;AAC1E,eAAe,yCAAyC,EAAE,EAAE,QAAQ;AACpE,iBAAiB,2CAA2C,EAAE,EAAE,UAAU;;AAE1E;EACE,SAAO;EACP,0BAA0B,EAAE,cAAc;AAC5C;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,4BAA4B,EAAE,gBAAgB;EAC9C,iBAAiB;EACjB,eAAe;EACf,UAAU;EACV,cAAc;AAChB;;AAEA;EACE,0BAA0B,EAAE,uBAAuB;AACrD;;AAEA;EACE,OAAO,2BAA2B,EAAE,UAAU,EAAE;EAChD,KAAK,wBAAwB,EAAE,UAAU,EAAE;AAC7C;;AAEA,2BAA2B;AAC3B;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,4BAA4B,EAAE,gBAAgB;EAC9C,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,2BAA2B,EAAE,eAAe;AAC9C;;AAEA,yBAAyB;AACzB;EACE,+BAA+B,EAAE,0BAA0B;EAC3D,uCAAuC,EAAE,iBAAiB;EAC1D,sCAAsC,EAAE,wBAAwB;EAChE,oBAAoB;EACpB,gBAAgB;EAChB,iBAAiB;EACjB,4BAA4B,EAAE,qBAAqB;AACrD;;AAEA;EACE,yBAAyB;EACzB,UAAU;AACZ;;AAEA,oBAAoB;AACpB;EACE,eAAe;EACf,sCAAsC,EAAE,iBAAiB;EACzD,SAAS;EACT,2BAA2B;EAC3B,mCAAmC,EAAE,2BAA2B;EAChE,2BAA2B,EAAE,eAAe;EAC5C,kBAAkB;EAClB,sCAAsC;EACtC,4BAA4B;EAC5B,sCAAsC,EAAE,iBAAiB;EACzD,aAAa;EACb,wCAAwC;AAC1C;;AAEA;EACE,WAAW,oCAAoC,EAAE,UAAU,EAAE;EAC7D,MAAM,uCAAuC,EAAE,YAAY,EAAE;AAC/D;;AAEA,6BAA6B;AAC7B;EACE,eAAe;EACf,YAAY;EACZ,UAAU;EACV,6BAA6B,EAAE,qBAAqB;EACpD,sBAAsB;EACtB,wCAAwC,EAAE,eAAe;EACzD,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,aAAa;EACb,4BAA4B;EAC5B,iBAAiB;AACnB;;AAEA;EACE,sCAAsC,EAAE,iBAAiB;EACzD,2BAA2B,EAAE,eAAe;AAC9C;;AAEA;EACE,oCAAoC,EAAE,eAAe;EACrD,yBAAyB,EAAE,aAAa;AAC1C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA,4CAA4C,gCAAgC,EAAE;AAC9E,6CAA6C,8BAA8B,EAAE;;AAE7E,+BAA+B;AAC/B;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;AACX;;AAEA,yBAAyB;AACzB;EACE,qCAAqC,EAAE,gBAAgB;EACvD,mBAAmB;AACrB;;AAEA,yBAAyB;AACzB;EACE,kBAAkB;EAClB,UAAU;EACV,OAAO;EACP,kCAAkC,EAAE,iBAAiB;EACrD,YAAY;EACZ,oBAAoB;EACpB,qBAAqB;EACrB,4CAA4C,EAAE,yBAAyB;EACvE,cAAc;EACd,yBAAyB,EAAE,mBAAmB;AAChD;;AAEA;EACE,MAAM;AACR;;AAEA,4BAA4B;AAC5B;EACE;IACE,UAAU;IACV,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,UAAU;IACV,WAAW;IACX,eAAe;IACf,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,qCAAqC;IACrC,uCAAuC;IACvC,sCAAsC;IACtC,gCAAgC,EAAE,0BAA0B;EAC9D;AACF","sourcesContent":["/* frontend/src/styles/Production.css - UPDATED WITH LIGHT THEME */\n\n/* Error Boundary Styles */\n.error-boundary {\n  min-height: 100vh;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: var(--bg-secondary); /* Light gray background */\n  text-align: center;\n  padding: 2rem;\n}\n\n.error-boundary h1 {\n  color: var(--error-color); /* Red error text */\n  margin-bottom: 1rem;\n}\n\n.error-boundary p {\n  color: var(--text-secondary); /* Medium gray text */\n  margin-bottom: 1.5rem;\n}\n\n/* Use primary button style for refresh */\n.error-boundary .submit-button {\n  /* Inherit styles from ResumeEnhancement.css or define here */\n  background-image: var(--gradient-button);\n  background-color: var(--primary-red-medium);\n  color: var(--text-on-gradient);\n  padding: 0.75rem 1.5rem;\n  font-size: 1rem;\n  font-weight: 600;\n  border: none;\n  border-radius: var(--border-radius-full);\n  cursor: pointer;\n  transition: all 0.3s ease;\n  min-width: 150px;\n}\n.error-boundary .submit-button:hover:not(:disabled) {\n  box-shadow: var(--shadow-button-hover);\n  transform: scale(1.03);\n}\n\n/* Loading Spinner Container */\n.loading-spinner-container {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(255, 255, 255, 0.9); /* White overlay */\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 9999;\n}\n\n.loading-spinner {\n    text-align: center;\n}\n\n.loading-spinner .spinner {\n  width: 60px;\n  height: 60px;\n  border: 4px solid rgba(0, 0, 0, 0.1); /* Light gray spinner track */\n  border-top-color: var(--text-accent); /* Red spinner color */\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n  margin: 0 auto 1rem; /* Added margin */\n}\n\n.loading-spinner p {\n  color: var(--text-primary); /* Dark text */\n  font-size: 1.2rem;\n}\n\n@keyframes spin {\n  to { transform: rotate(360deg); }\n}\n\n/* Toast Notifications */\n.toast-container {\n  position: fixed;\n  top: calc(var(--navbar-height) + 1rem); /* Position below navbar */\n  right: 20px;\n  z-index: 9999;\n  max-width: 400px; /* Limit width */\n}\n\n.toast {\n  background: var(--bg-primary); /* White background */\n  color: var(--text-primary); /* Dark text */\n  border-radius: var(--border-radius-lg); /* Consistent rounding */\n  padding: 1rem 1.5rem;\n  margin-bottom: 1rem;\n  box-shadow: var(--shadow-xl); /* Use defined shadow */\n  animation: slideIn 0.3s ease;\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n}\n\n.toast.success { border-left: 4px solid var(--success-color); } /* Green */\n.toast.error { border-left: 4px solid var(--error-color); } /* Red */\n.toast.warning { border-left: 4px solid var(--warning-color); } /* Amber */\n\n.toast-message {\n  flex: 1;\n  color: var(--text-primary); /* Dark text */\n}\n\n.toast-close {\n  background: none;\n  border: none;\n  color: var(--text-secondary); /* Medium gray */\n  font-size: 1.5rem;\n  cursor: pointer;\n  padding: 0;\n  line-height: 1;\n}\n\n.toast-close:hover {\n  color: var(--text-primary); /* Dark gray on hover */\n}\n\n@keyframes slideIn {\n  from { transform: translateX(100%); opacity: 0; }\n  to { transform: translateX(0); opacity: 1; }\n}\n\n/* Secure Form Indicators */\n.secure-indicator {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  color: var(--text-secondary); /* Medium gray */\n  font-size: 0.9rem;\n  margin-top: 0.5rem;\n}\n\n.secure-indicator svg {\n  width: 16px;\n  height: 16px;\n  color: var(--success-color); /* Green icon */\n}\n\n/* File Upload Security */\n.file-security-notice {\n  background: var(--bg-secondary); /* Light gray background */\n  border: 1px solid var(--border-primary); /* Light border */\n  border-radius: var(--border-radius-lg); /* Consistent rounding */\n  padding: 0.8rem 1rem;\n  margin-top: 1rem;\n  font-size: 0.9rem;\n  color: var(--text-secondary); /* Medium gray text */\n}\n\n.file-security-notice ul {\n  margin: 0.5rem 0 0 1.5rem;\n  padding: 0;\n}\n\n/* Session Warning */\n.session-warning {\n  position: fixed;\n  top: calc(var(--navbar-height) + 1rem); /* Below navbar */\n  left: 50%;\n  transform: translateX(-50%);\n  background: var(--warning-bg-light); /* Light amber background */\n  color: var(--warning-color); /* Amber text */\n  padding: 1rem 2rem;\n  border-radius: var(--border-radius-lg);\n  box-shadow: var(--shadow-lg);\n  border: 1px solid var(--warning-color); /* Amber border */\n  z-index: 9998;\n  animation: pulseWarning 2s ease infinite;\n}\n\n@keyframes pulseWarning {\n  0%, 100% { transform: translateX(-50%) scale(1); opacity: 1; }\n  50% { transform: translateX(-50%) scale(1.02); opacity: 0.9; }\n}\n\n/* Network Status Indicator */\n.network-status {\n  position: fixed;\n  bottom: 20px;\n  left: 20px;\n  background: var(--bg-primary); /* White background */\n  padding: 0.8rem 1.5rem;\n  border-radius: var(--border-radius-full); /* Pill shape */\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  z-index: 1000;\n  box-shadow: var(--shadow-lg);\n  font-size: 0.9rem;\n}\n\n.network-status.online {\n  border: 1px solid var(--success-color); /* Green border */\n  color: var(--success-color); /* Green text */\n}\n\n.network-status.offline {\n  border: 1px solid var(--error-color); /* Red border */\n  color: var(--error-color); /* Red text */\n}\n\n.network-indicator {\n  width: 10px;\n  height: 10px;\n  border-radius: 50%;\n  animation: pulse 2s infinite;\n}\n\n.network-status.online .network-indicator { background: var(--success-color); }\n.network-status.offline .network-indicator { background: var(--error-color); }\n\n/* Accessibility Improvements */\n.sr-only {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  white-space: nowrap;\n  border: 0;\n}\n\n/* Focus Visible Styles */\n*:focus-visible {\n  outline: 2px solid var(--text-accent); /* Red outline */\n  outline-offset: 2px;\n}\n\n/* Skip to Content Link */\n.skip-to-content {\n  position: absolute;\n  top: -40px;\n  left: 0;\n  background: var(--gradient-button); /* Red gradient */\n  color: white;\n  padding: 0.5rem 1rem;\n  text-decoration: none;\n  border-radius: 0 0 var(--border-radius-lg) 0; /* Rounded bottom right */\n  z-index: 10000;\n  transition: top 0.3s ease; /* Add transition */\n}\n\n.skip-to-content:focus {\n  top: 0;\n}\n\n/* Responsive improvements */\n@media (max-width: 768px) {\n  .toast-container {\n    left: 20px;\n    right: 20px;\n    max-width: none;\n  }\n\n  .session-warning {\n    left: 20px;\n    right: 20px;\n    transform: none;\n    text-align: center;\n  }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  * {\n    animation-duration: 0.01ms !important;\n    animation-iteration-count: 1 !important;\n    transition-duration: 0.01ms !important;\n    scroll-behavior: auto !important; /* Disable smooth scroll */\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
